const entrance = {}

export default entrance
